import React, { FC } from "react";

const Loading: FC = () => {
    return <div className="fixed top-0 left-0 w-full h-screen flex justify-center items-center backdrop-blur-sm  z-50">
        <img src="/img/load.gif" className="w-20 h-20" alt="" />
    </div>
}

export default Loading;